module.exports = __webpack_public_path__ + "static/media/chas-logo-row.f4ec4ddf.svg";